import React, { Component } from "react";

import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import env from "../../../../utils/env";

import "./UpsellCTA.css";

class UpsellCTA extends Component {
  componentDidMount() {
    // Add Popupmaker class to trigger Wordpress Popup
    // In the future this shoul be replaced with a non-wp method
    //
    // For now it looks like this popup doesn't function as it should.
    // var element = document.getElementById("upsell-cta");
    // element.classList.add("popmake-508");
  }

  render() {
    const { title, description, ctaLabel, onClick } = this.props;
    return (
      <div>
        <div className="upsell-box d-flex flex-fdc flex-jc pad-8 ta-center ff-ns">
          <div className="fs-16 fw-bold lh-lg">{title}</div>
          <div className="fs-14 fw-normal lh-sm">{description}</div>
        </div>
        <Button
          id={"upsell-cta"}
          type={buttonTypes.PRIMARY.value}
          action={actionTypes.CALL_TO_ACTION.value}
          label={ctaLabel}
          style={{ width: "100%" }}
          onClick={e => {
            onClick(e);
            window.location = `${env.envURL}/upgrade-confirmation`;
          }}
        />
      </div>
    );
  }
}
export default UpsellCTA;



// WEBPACK FOOTER //
// ./src/Components/Panels/CustomizePanel/UpsellCTA/UpsellCTA.js